import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getZoneListById, saveZoneData, updateZoneData } from "../../redux/actions/ZoneActions";
import FormInput from "../../Components/FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getAllCityList } from "../../redux/actions/MasterActions";
import Preloader from "../../Components/Preloader";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddZone = ({ show, onHide, editId }) => {
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    zoneReducer: {
      zonePermissions,
      loadingZone,
      errorsZone,
      zoneLists,
      changedZoneStatus,
    },
    masterReducer: {
      loadingMaster,
      errorsMaster,
      masterAllCityList,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.token) {
      dispatch(getAllCityList(auth.token));
    }
  }, [auth?.token]);

  useEffect(() => {
    setFormData({})
    if(editId) {
      dispatch(getZoneListById(auth?.token, editId));
    }
  }, [auth, editId]);

  
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if(editId)
    {
      dispatch(updateZoneData(auth?.token, formData,editId));
    }
    else
    {
      dispatch(saveZoneData(auth?.token, formData));
    }
  };

  useEffect(()=>{
    if(editId && zoneLists && Object.keys(zoneLists).length > 0) {
      setFormData({
        zone_name: zoneLists.zone_name,
        city_id: JSON.parse(zoneLists.city_id) || [],
      });
    }
  },[zoneLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide(); // Close modal on logout
    }
  }, [errors, dispatch, onHide]);

  useEffect(() => {
    if (errorsMaster && Object.keys(errorsMaster).length > 0) {
      if(errorsMaster?.status==401){
        dispatch(logout())
        toast.error(errors?.data?.message);
        onHide();
      }
    }
  }, [errorsMaster]);

  useEffect(() => {
    if (changedZoneStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedZoneStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_ZONE_STATUS' });
    }
  }, [changedZoneStatus, dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const selectHandler = (selectedData, name) => {
    const selectedValues = selectedData.map((item) => item.city_code);
  
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selectedValues,
    }));
  };

  const customSelectStyles = {
    control: (base, qr) => ({
      ...base,
      borderColor: errors?.data?.city_code ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errors?.data?.city_code ? 'red' : base.borderColor,
      }
    }),
  };


  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(editId && zoneLists && Object.keys(zoneLists).length > 0) ? t("Update Zone") : t("Add Zone")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
            {errorsZone?.data?.message && (
              <div className="alert alert-danger">
                {errorsZone?.data?.message}
              </div>
            )}
          <Row>
            <Col lg={12}>
              <Form.Group className="mb-3">
                <Form.Label>{t("City")} <span style={{color:'red',fontSize:15}}>*</span></Form.Label>
                <Select
                  options={masterAllCityList.map((city) => ({
                    ...city,
                    label: `${city?.city_name} (${city?.cities_state?.state_name})`, 
                  }))}
                  multi
                  values={masterAllCityList.map((city) => ({
                    ...city,
                    label: `${city?.city_name} (${city?.cities_state?.state_name})`, 
                  })).filter((city) =>
                    formData.city_id?.includes(city.city_code)
                  )}
                  name="city_id"
                  labelField="label"
                  valueField="city_code"
                  searchBy="label"
                  loading={loadingMaster}
                  onChange={(selectedData) => selectHandler(selectedData, "city_id")}
                  styles={customSelectStyles}
                  clearable={true}
                  keepSelectedInList={true}
                  selectAll={true}
                  
                />
                {errorsZone?.data?.city_id && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{errorsZone?.data?.city_id}</p>
                  </div>
                )}
              </Form.Group>
            </Col>

            <Col lg={12}>
              <FormInput
                label={t("Zone Name")}
                type="text"
                errors={errorsZone?.data}
                value={formData.zone_name}
                name="zone_name"
                required={true}
                onChange={inputHandler}
                containerClass={"mb-3"}
                disabled={!!editId}
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-center">
            {loading ? 
              <Button color="primary" disabled>
                <Spinner animation="border" size="sm" />
                {t("Please wait ...")}
              </Button>
            :
              <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
                {t("Submit")}
              </Button>
            }
          </div>
        
      </Modal.Body>
      {loadingZone && <Preloader />}
    </Modal>
  );
};

export default AddZone;
